/**
 * Created by Ivan on 20.06.2026
 */

Mission.TYPE_LORYS_DERBY = 103;

Mission.REGISTRATIONS.set(Mission.TYPE_LORYS_DERBY, () => ({
    available: cleverapps.config.availables.LORYS_DERBY_MISSION,
    name: "LorysDerby",
    logic: LorysDerby,
    view: LorysDerbyWindow,
    startWindow: LorysDerbyStartWindow,
    stages: bundles.lorys_derby_stages.jsons.stages_config_json.getJson(),
    schedule: "FRI-MON",
    semaphore: Mission.SEMAPHORE_ALWAYS,
    abTest: () => cleverapps.abExperiments.getGroup(ABExperiments.Tests.lorysDerbyLadacha) !== "B",
    bundle: "lorys_derby",
    sideBarJson: cleverapps.config.type === "merge2" ? bundles.sidebar.jsons.lorysderby_icon_json : false,
    rowView: cleverapps.config.type === "merge2" ? function (row) {
        return Prefab.instantiate(bundles.merge.jsons.lorysderby_row_prefab_json, { mission: row.data.mission });
    } : undefined
}));
